module.exports = __webpack_public_path__ + "static/media/version.336a1e4e.png";